import React from 'react'
import { Avatar, Box, TableCell, TableRow, Typography } from '@mui/material'
import type { FacilitatorLiveSessionParticipant } from '../../../../../../pure-js/types/FacilitatorLiveSessionMonitor'
import { ControlTowerSignalCell } from './ControlTowerSignalCell'
import { getAvatarColor, getInitials } from './controlTowerHelpers'
import {
  buildControlTowerAvatarSx,
  controlTowerRosterBodyCellSx,
  controlTowerRosterNameLineSx,
  controlTowerRosterNameSx,
  controlTowerRosterPersonSx,
  controlTowerRosterTeamSx
} from './controlTowerStyles'

interface ControlTowerParticipantRowProps {
  participant: FacilitatorLiveSessionParticipant
  showPlayedColumn: boolean
  testId: string
}

/** One person on a card's roster: who they are, their team beside the name on a sprint-wide card, and their signals. */
export const ControlTowerParticipantRow: React.FC<ControlTowerParticipantRowProps> = ({
  participant,
  showPlayedColumn,
  testId
}) => {
  const hasTeamName = !!participant.teamName

  return (
    <TableRow role="row" data-testid={testId}>
      <TableCell role="cell" sx={controlTowerRosterBodyCellSx}>
        <Box sx={controlTowerRosterPersonSx}>
          <Avatar sx={buildControlTowerAvatarSx(getAvatarColor(participant.name))}>
            {getInitials(participant.name)}
          </Avatar>

          <Box sx={controlTowerRosterNameLineSx}>
            <Typography sx={controlTowerRosterNameSx} noWrap>
              {participant.name}
            </Typography>
            {hasTeamName && (
              <Typography sx={controlTowerRosterTeamSx} noWrap>
                {participant.teamName}
              </Typography>
            )}
          </Box>
        </Box>
      </TableCell>

      <ControlTowerSignalCell isOn={participant.inMeeting} testId={`${testId}-in-meet`} />
      {showPlayedColumn && <ControlTowerSignalCell isOn={participant.playedThisLoop} testId={`${testId}-played`} />}
    </TableRow>
  )
}
